import CircularProgress from '@material-ui/core/CircularProgress';
import { LOGO_THUOCSI_SHORTENED } from 'constants/Images';
import { ImageFallbackStatic } from 'utils/ImageFallback';
import styles from './styles.module.css';

export default function LoadingBM() {
  return (
    <div className={styles.wrapLoad}>
      <div className={styles.wrapper}>
        <ImageFallbackStatic src={LOGO_THUOCSI_SHORTENED} width={45} height={45} />
        <CircularProgress size={80} thickness={4} className={styles.progress} />
      </div>
    </div>
  );
}

